export const alldata = [
  {
    name: '1995',
    City: 7,
    Campus: 0,
  },
  {
    name: '1996',
    City: 3,
    Campus: 3,
  },
  {
    name: '1997',
    City: 5,
    Campus: 0,
  },
  {
    name: '1998',
    City: 5,
    Campus: 1,
  },
  {
    name: '1999',
    City: 6,
    Campus: 0,
  },
  {
    name: '2000',
    City: 9,
    Campus: 0,
  },
  {
    name: '2001',
    City: 11,
    Campus: 0,
  },
  {
    name: '2002',
    City: 28,
    Campus: 0,
  },
  {
    name: '2003',
    City: 27,
    Campus: 2,
  },
  {
    name: '2004',
    City: 9,
    Campus: 2,
  },
  {
    name: '2005',
    City: 8,
    Campus: 1,
  },
  {
    name: '2006',
    City: 10,
    Campus: 2,
  },
  {
    name: '2007',
    City: 3,
    Campus: 3,
  },
  {
    name: '2008',
    City: 0,
    Campus: 5,
  },
  {
    name: '2009',
    City: 1,
    Campus: 3,
  },
  {
    name: '2010',
    City: 1,
    Campus: 15,
  },
  {
    name: '2011',
    City: 4,
    Campus: 0,
  },
  {
    name: '2012',
    City: 8,
    Campus: 5,
  },
  {
    name: '2013',
    City: 13,
    Campus: 7,
  },
  {
    name: '2014',
    City: 3,
    Campus: 8,
  },
  {
    name: '2015',
    City: 4,
    Campus: 2,
  },
  {
    name: '2016',
    City: 13,
    Campus: 4,
  },
  {
    name: '2017',
    City: 23,
    Campus: 5,
  },
  {
    name: '2018',
    City: 17,
    Campus: 0,
  },
  {
    name: '2019',
    City: 8,
    Campus: 0,
  },
  {
    name: '2020',
    City: 7,
    Campus: 0,
  },
];

export const data1 = [
  {
    name: 'Anti-gender',
    National: 386,
    California: 21,
  },
  {
    name: 'Multibias',
    National: 761,
    California: 30,
  },
  {
    name: 'Disability-motivated',
    National: 1834,
    California: 94,
  },
];

export const data2 = [
  {
    name: 'Anti-religion',
    National: 32432,
    California: 5569,
  },
  {
    name: 'Anti-LGBTQ+',
    National: 35731,
    California: 7620,
  },
  {
    name: 'Anti-race',
    National: 120834,
    California: 22191,
  },
];
